import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=9af6d912&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af6d912",
  null
  
)

export default component.exports